import React from "react";
import { formatDateInJobStatsLog } from "../../../../utils";
import MessageMediaGrid from "../../../components/messageMediaGrid/MessageMediaGrid";
import { theme } from "../../../../theme";

const Right = ({ message }) => {
    const { hasFiles, imageGridStyle, imageStyle } = MessageMediaGrid(message);

    return (
        <div className="row justify-content-end text-right mb-4">
            <div
                className="d-flex align-items-start justify-content-end"
                style={{ width: "100%" }}
            >
                {/* 💬 Message */}
                <div
                    className={hasFiles ? "col-5" : "col-auto"}
                    style={{ width: "90%" }}
                >
                    <div className="card bg-gradient-success">
                        <div
                            className={`card-body ${
                                hasFiles ? "p-2" : "py-2 px-3"
                            } text-white`}
                        >
                            {/* Sender */}
                            <p className="text-sm text-bold mb-1">
                                {message.message_sender?.user_name} (
                                {message.message_sender?.user_type})
                            </p>

                            {/* Message */}
                            {message.message_content?.text && (
                                <p className="text-sm mt-0 mb-0">
                                    {message.message_content.text}
                                </p>
                            )}

                            {/* Images */}
                            {hasFiles && (
                                <div style={imageGridStyle}>
                                    {message.message_content.files.map(
                                        (image, index) => (
                                            <a
                                                key={index}
                                                href={image.path}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    src={image.path}
                                                    alt="chat-img"
                                                    style={imageStyle}
                                                />
                                            </a>
                                        )
                                    )}
                                </div>
                            )}

                            {/* Time */}
                            <div className="d-flex align-items-center justify-content-end text-sm opacity-6 mt-1">
                                <i className="material-symbols-rounded">
                                    move_to_inbox
                                </i>
                                <small className="text-bold ms-1">
                                    {formatDateInJobStatsLog(
                                        message?.message_time
                                    )}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 👤 User Icon (RIGHT SIDE) */}
                <div
                    style={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        backgroundColor: theme.main_code,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: 10,
                        flexShrink: 0,
                    }}
                >
                    <i className="material-symbols-rounded text-light">
                        person
                    </i>
                </div>
            </div>
        </div>
    );
};

export default Right;